
import * as _ from 'lodash';
import { IKioskModel, IkioskManager } from '../../models/kioskModel';
import * as types from './actionTypes';
import { getIdleSelectionTimer } from '../../helpers/helpersIndex';

const initialState = { selectedArea: IkioskManager.FIRSTPASSWELCOME } as IKioskModel;

const kioskReducer = (state = initialState, action) => {
    let undefinedData;
    switch (action.loadingType) {
        case types.SET_LOADING:
            state = {
                ...state,
                loading: action.loadPayload
            }
            break;
        default:
            break;
    }

    switch (action.type) {
        case types.SET_KIOSK_ID_AND_GET_MENUS_DATA_RESPONSE:
            const { kioskId, themeName, menusTData, errorMessag, isLicenseActive, kioskStartTime, kioskEndTime, kioskIdentifier, kioskType, isFeedback, locationId, isEnabledDobAuth, kioskStatus } = action.payload;
            state = {
                ...state,
                isLicenseActive: isLicenseActive,
                kioskId: kioskId,
                kioskIdentifier: kioskIdentifier,
                kioskStartTime: kioskStartTime,
                kioskEndTime: kioskEndTime,
                kioskType: kioskType,
                isFeedback: isFeedback,
                locationId: locationId,
                isEnabledDobAuth: isEnabledDobAuth,
                kioskStatus: kioskStatus
            }
            if (!errorMessag) {
                state = {
                    ...state,
                    theme: themeName,
                    menusTData: menusTData
                }
            }
            else
                state = {
                    ...state,
                    errorMessage: errorMessag
                }
            break;

        case types.SET_LANGUAGE_RESPONSE:
            const { language } = action.payload;
            state = {
                ...state,
                // menusData: menuData,
                language: language,
                selectedArea: IkioskManager.PATIENTJOUNEYEXPLORE
            }
            break;
        case types.SET_KIOSK_MENU_SELECTION_RESPONCE:
            const { selectedMenu, selectedArea, menuId, errorMessage } = action.payload
            if (selectedArea) {
                state = {
                    ...state,
                    selectedArea: selectedArea,
                    selectedMenu: selectedMenu,
                    errorMessage: errorMessage,
                    menuId: menuId
                }
            }
            else {
                state = {
                    ...state,
                    selectedMenu: undefinedData,
                    templateData: undefinedData,
                    errorMessage: undefinedData,
                    selectedArea: IkioskManager.HOME
                }
            }
            break;
        case types.SUSPEND_ERROR_METHOD:
            state = {
                ...state,
                errorMessage: undefinedData,
                selectedArea: action.payload
            }
            break;
        case types.BACK_ACTION_RESPONSE:
            state = {
                ...state,
                selectedArea: action.payload?.selectedArea,
                emiratesData: action.payload?.clearEmiratesData ? undefinedData : state.emiratesData,
                printButtondisble: false
            }
            break;
        case types.EXIT_ACTION:
            state = {
                ...state,
                language: undefinedData,
                selectedArea: IkioskManager.HOME,
                mrnNo: undefinedData,
                selectedMenu: undefinedData,
                appointmentsData: undefinedData,
                errorMessage: undefinedData,
                tokenNo: undefinedData,
                templateData: undefinedData,
                inputNumber: undefinedData,
                emiratesData: undefinedData,
                printButtondisble: false
            }
            break;
        case types.TOKEN_TEMPLATE_AREA_RESPONSE:
            const { tokenTemplate, templatesData, token, mrn, currentSelectedArea, errorMsg } = action.payload;
            if (!errorMsg)
                state = {
                    ...state,
                    templateData: {
                        templateOrg: tokenTemplate,
                        templates: templatesData,
                        mrnNo: mrn,
                        tokenNo: token
                    },
                    tokenNo: token,
                    selectedArea: currentSelectedArea,
                    errorMessage: errorMsg
                }
            else
                state = {
                    ...state,
                    errorMessage: errorMsg
                }
            break;
        case types.APPOINTMENTS_AREA_RESPONSE:
            state = {
                ...state,
                appointmentsData: action.payload.appointmentsData,
                selectedArea: action.payload.currentSelectedArea,
                errorMessage: action.payload.errorMsg,
                timer: getIdleSelectionTimer() * 1000
            }
            break;
        case types.SELECTED_KIOSK_MODE:
            state = {
                ...state,
                selectedArea: action.payload.mode,
                mrnNo: action.payload.mrnNo,
                errorMessage: action.payload.errorMessage
            }
            break;
        case types.APPOINTMENT_CHECKEIN_RESPONSE:
            if (!action.payload.errorMsge)
                state = {
                    ...state,
                    selectedArea: action.payload.selectedArea,
                    tokenNo: action.payload.tokenNo,
                    templateData: {
                        templateOrg: action.payload.tokenTemplate,
                        templates: action.payload.templatesData,
                        mrnNo: action.payload.mrnNo,
                        tokenNo: action.payload.tokenNo
                    },
                }
            else
                state = {
                    ...state,
                    errorMessage: action.payload.errorMsge
                }
            break;
        case types.GET_CURRENT_DATE_TIME_RESPONSE:
            state = {
                ...state,
                dateTime: action.payload
            }
            break;
        case types.GET_FEEDBACK_RESPONSE:
            state = {
                ...state,
                errorMessage: action.payload
            }
            break;
        case types.GET_EMIRATES_ID_RESPONSE:
            if (action.payload.errorMessage)
                state = {
                    ...state,
                    emiratesData: undefinedData,
                    mrnNo: undefinedData,
                    errorMessage: action.payload.errorMessage
                }
            else
                state = {
                    ...state,
                    emiratesData: action.payload.data,
                    selectedArea: IkioskManager.APPOINTMENTSAREA,
                    errorMessage: ''
                }
            break;
        case types.IDLE_ERROR_MESSAGE:
            state = {
                ...state,
                errorMessage: action.payload
            }

            break;
        case types.KIOSK_REFRESH_TIME_UPDATE:
            state = {
                ...state,
                kioskRefreshTime: action.payload
            }
            break;
        case types.SET_RESET_FOR_KIOSK_START_TIME_AND_END_TIME:
            state = {
                ...state,
                kioskEndTime: '',
                kioskStartTime: ''
            }
            break;
        case types.GET_PAYMENT_DETAILS_RESPONSE:
            if (action?.payload?.selectedArea) {
                state = {
                    ...state,
                    selectedArea: action?.payload?.selectedArea,
                    errorMessage: errorMessage
                }
            }
            else {
                state = {
                    ...state,
                    selectedMenu: undefinedData,
                    templateData: undefinedData,
                    errorMessage: undefinedData,
                    selectedArea: IkioskManager.HOME
                }
            }
            break;
        case types.GET_PAYMENT_MODE:
            state = {
                ...state,
                selectedArea: action?.payload
            }
            break;
        case types.GET_DEPARTMENTS_RESPONSE:
            state = {
                ...state,
                departments: action?.payload?.departments,
                errorMessage: action?.payload?.errorMessage
            }
            break;
        case types.GET_DOCTORS_RESPONSE:
            state = {
                ...state,
                doctorsData: action?.payload?.doctorsList,
                selectedServiceCode: action?.payload?.serviceCode,
                timeSchedules: action?.payload?.timeSchdulesData,
                selectedScheduleTime: undefinedData,
                selectedDoctorId: undefinedData,
                searchkey: undefinedData,
                errorMessage: action?.payload?.errorMessage
            }
            break;
        case types.SEARCHKEY:
            state = {
                ...state,
                searchkey: action.payload
            }
            break;
        case types.SELECTEEDOCTOR:
            state = {
                ...state,
                selectedDoctorId: action.payload
            }
            break;
        case types.SELECTEDTIME:
            state = {
                ...state,
                selectedScheduleTime: action.payload
            }
            break;
        case types.WALKIN_APPOINTMENT_RESPONSE:
            state = {
                ...state,
                errorMessage: action.payload.errorMessage
            }
            break;
        case types.IS_DOB_AUTHENTICATION_ACTION:
            state = {
                ...state,
                selectedArea: action?.payload?.page,
                inputNumber: action?.payload?.mobileNo
            }
            break;
        case types.VERIFY_INPUT_RSPONSE:
            state = {
                ...state,
                errorMessage: action.payload,
                selectedArea: IkioskManager.EMIRADESVERIFICATION
            }
            break;
        case types.REDIRECT_PAGE:
            state = {
                ...state,
                selectedArea: action.payload
            }
            break;
        case types.PRINT_TOKEN_RESPONSE:
            state = {
                ...state,
                errorMessage: action.payload,
                printButtondisble: false
            }
            break;
        case types.PRINT_TOKEN_REQUEST:
            state = {
                ...state,
                printButtondisble: true
            }
            break;
        case types.GET_EMIRATES_ID_REQUEST:
        case types.MRN_SUBMIT_REQUEST:
            state = {
                ...state,
                selectedArea: IkioskManager.LOADAPPOINTMENTS
            }
            break;
        case types.FIRSPASSWELCOMEPAGE:
            state = {
                ...state,
                selectedArea: IkioskManager.FIRSTPASSWELCOME
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}
export default kioskReducer;